import React, { useContext, useEffect, useState } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { getFirestore, collection, onSnapshot } from 'firebase/firestore';
import '../../utils/firebaseConfig';
import { FiltersContext, OptionsContext } from '../../context';
import { Context } from '../../context/Context';
import { makeStyles } from '@mui/styles';
import ErrorView from '../../ErrorView';
import LoadingWidget from '../LoadingWidget';
import Maintenance from '../../views/Maintenance';
import { remountOnSpeciesChange } from '../SpeciesDropdown/speciesRoutes';
import { UnsavedChangesProvider } from '../../context/UnsavedChangesContext';

const useStyles = makeStyles((theme) => ({
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
  },
}));

const RouteWithLayout = (props) => {
  const {
    layout: Layout,
    component: Component,
    flex,
    moduleId = '',
    ...rest
  } = props;

  // ahora recibe flex como prop para poder hacer que el contenido del componente se muestre block o flex

  const { logout } = useContext(Context);

  const {
    state: { isLoading, specie_filter },
    logOutFilters,
  } = useContext(FiltersContext);

  const { clearOptions } = useContext(OptionsContext);

  const classes = useStyles();

  const history = useHistory();

  // console.log('RouteWithLayout', isLoading);

  const [dataMaintenanceState, setDataMaintenanceState] = useState([]);

  const [maintenanceModeState, setMaintenanceModeState] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const db = getFirestore();
      const mantenimientoCollection = collection(db, 'Mantenimiento');
      const unsubscribe = onSnapshot(mantenimientoCollection, (snapshot) => {
        const data = [];
        snapshot.forEach((doc) => {
          data.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        setDataMaintenanceState(data);
      });

      return () => {
        // Unsubscribe from the snapshot listener when the component unmounts
        unsubscribe();
      };
    };
    fetchData();
  }, []);

  const errorHandler = (error, errorInfo) => {
    console.log('//*--------error general: ', error, errorInfo);
    console.log(error?.response?.data, '-------NO AUTH');

    if (
      error?.response?.data?.error &&
      error?.response?.data?.error.includes('no autenticado')
    ) {
      console.log('ENTRO');
      logOutFilters();
      clearOptions();
      logout();
      // history.push('/sign-in');
    }
  };

  useEffect(() => {
    if (dataMaintenanceState) {
      // console.log('dataMaintenanceState', dataMaintenanceState);
      const filterData = dataMaintenanceState.find(
        (item) => item.name === 'plataformaWeb'
      );

      // console.log('filterData', filterData);

      if (filterData) {
        if (filterData.status === true) {
          if (location.pathname !== '/maintenance') {
            setMaintenanceModeState(true);
          }
        } else {
          setMaintenanceModeState(false);
        }
      }
    }
  }, [dataMaintenanceState]);

  // console.log(isLoading, 'isLoading');

  if (isLoading) {
    return (
      <div className={classes.loadingContainer}>
        <LoadingWidget />
      </div>
    );
  }

  if (maintenanceModeState) {
    return (
      <div className={classes.loadingContainer}>
        <Maintenance
          status={maintenanceModeState}
          dataMaintenance={dataMaintenanceState.find(
            (item) => item.name === 'plataformaWeb'
          )}
        />
      </div>
    );
  }

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <ErrorBoundary
          key={remountOnSpeciesChange(matchProps.location.pathname) ? specie_filter : 'route'}
          FallbackComponent={ErrorView}
          onError={errorHandler}
        >
          <UnsavedChangesProvider>
            <Layout flex={flex} moduleId={moduleId} {...rest}>
              <Component
                key={remountOnSpeciesChange(matchProps.location.pathname) ? specie_filter : 'view'}
                {...matchProps}
              />
            </Layout>
          </UnsavedChangesProvider>
        </ErrorBoundary>
      )}
    />
  );
};

export default RouteWithLayout;
